import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { supabase } from '@/lib/supabase';
import { NEXT_KEY } from '@/components/GoogleAuthButton';

function readError() {
  const q = new URLSearchParams(window.location.search);
  const h = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  return q.get('error_description') || h.get('error_description') || q.get('error') || h.get('error');
}

function safeNext() {
  const n = sessionStorage.getItem(NEXT_KEY) || '/app';
  sessionStorage.removeItem(NEXT_KEY);
  return n.startsWith('/') && !n.startsWith('//') ? n : '/app';
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const err = readError();
    if (err || !supabase) {
      toast.error(/denied|cancel/i.test(err || '') ? 'Connexion Google annulée.' : 'La connexion Google a échoué. Réessaie.', { duration: 8000 });
      navigate('/login', { replace: true });
      return undefined;
    }
    let done = false;
    const finish = (session) => {
      if (done || !session) return;
      done = true;
      navigate(safeNext(), { replace: true });
    };
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => finish(s));
    supabase.auth.getSession().then(({ data }) => finish(data.session));
    const t = setTimeout(() => { if (!done) setFailed(true); }, 10000);
    return () => { subscription.unsubscribe(); clearTimeout(t); };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center" data-testid="auth-callback">
      {failed ? (
        <>
          <p className="text-white">La connexion n'a pas pu être finalisée.</p>
          <button onClick={() => navigate('/login', { replace: true })} className="rounded-full bg-brand px-6 py-2.5 font-semibold text-black" data-testid="auth-callback-retry">
            Retour à la connexion
          </button>
        </>
      ) : (
        <><Loader2 className="h-8 w-8 animate-spin text-brand" /><p className="text-muted-foreground">Connexion en cours…</p></>
      )}
    </div>
  );
}
